import { useTranslation } from '@axo/shared/i18n';
import { getFormattedAmountUI } from '@axo/shared/util/formatters';
import { RefinanceSavings } from '@axo/ui-feature/components/RefinanceSavings';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { calculateRefinanceSavings } from '../../../utils/Finland/calculateRefinanceSavings';

export const RefinanceSaving = () => {
  const { t } = useTranslation();

  const amount = useWatch({ name: 'LoanApplication/AppliedAmount' });
  const duration = useWatch({ name: 'LoanApplication/LoanDuration' });

  const refinanceSaving = useMemo(
    () =>
      calculateRefinanceSavings({
        amount,
        duration,
      }),
    [amount, duration]
  );

  return (
    <RefinanceSavings
      title={t('RefinanceSavings.title')}
      disclaimer={t('RefinanceSavings.disclaimer')}
      savingCards={[
        {
          key: 'per_month',
          title: t('RefinanceSavings.per_month'),
          value: `${getFormattedAmountUI(refinanceSaving)} ${t(
            'suffix.currency'
          )}`,
        },
      ]}
    />
  );
};
